import { useEffect, useRef } from "react";
// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../ContactBand";
import HomeMedia from "../home/HomeMedia";
import HomeNews from "../home/HomeNews";

export default function HomePage() {
  // 取引先ロゴ帯：画面に半分以上入ったら is-visible（ロゴ帯の動きの開始）
  const partnersRef = useRef(null);
  useEffect(() => {
    const band = partnersRef.current;
    if (!band || !("IntersectionObserver" in window)) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          band.classList.toggle(
            "is-visible",
            e.isIntersecting && e.intersectionRatio >= 0.5,
          );
        }
      },
      { threshold: [0, 0.5] },
    );
    io.observe(band);
    return () => io.disconnect();
  }, []);

  return (
    <main>
      <section className="hero">
        <div className="hero-art">
          <img src="/assets/fv_wires.webp" alt="" className="" />
        </div>
        <div className="hero-copy">
          <div className="hero-panel">
            <h1>
              <span>先端技術で、</span>
              <br />
              <span>すべての人と企業を</span>
              <span>飛躍させる。</span>
            </h1>
            <p className="hero-sub">
              <span>
                LEAPSは、AIやブロックチェーンを軸にしたソリューションカンパニーです。
              </span>
              <br className="pc" />
              <span>
                デジタルインフラの構築や業務改革を通じて、企業の成長とより良い社会をつくります。
              </span>
            </p>
            <div className="hero-cta">
              <Link className="btn" to="/contact">
                <img src="/assets/icn_paperplane.svg" alt="" />
                無料相談
              </Link>
              <Link className="btn btn-sub" to="/services">
                サービス一覧
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className="partners" aria-label="取引先" ref={partnersRef}>
        <p>STAKE HOLDERS AND PARTNERS</p>
        <div className="partner-scroll">
          <div className="partner-logos">
            <div className="partner-group">
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-jtb.png"
                  alt="JTB"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-jta.png"
                  alt="JTA JR TOKAI AGENCY CO.,LTD."
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-azism.png"
                  alt="AZISM"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-mics.png"
                  alt="mics MEDICAL INFORMATICS"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-teamz.png"
                  alt="TEAMZ"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-consensusbase.png"
                  alt="Consensus Base"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-meitetsu-mirai.png"
                  alt="名鉄未来クリエイツ"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-pizzaday.png"
                  alt="PIZZA DAY"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-buk.png"
                  alt="BUK"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-wizlex.png"
                  alt="WIZLEX"
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-caramel.png"
                  alt="Caramel"
                  width="180"
                  height="60"
                />
              </span>
            </div>
            <div className="partner-group" aria-hidden="true">
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-jtb.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-jta.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-azism.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-mics.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-teamz.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-consensusbase.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-meitetsu-mirai.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-pizzaday.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-buk.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-wizlex.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
              <span className="logo-tile">
                <img
                  src="/assets/logos/logo-caramel.png"
                  alt=""
                  width="180"
                  height="60"
                />
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="section services">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            サービス<strong>Services</strong>
          </h2>
          <div className="svc-intro">
            <p className="svc-intro-lead">
              ソリューションとプロダクトで、
              <br />
              企業のデジタル変革を推進する。
            </p>
            <p className="svc-intro-text">
              お客様ごとの課題に向き合うソリューションと、そこで得た知見から生まれるプロダクト。
              <br className="pc" />
              この2つを循環させながら、AIやブロックチェーンを実際に使われる形にし、お客様のビジネスの未来を共に創造します。
            </p>
            <div className="duo">
              <div className="duo-stage">
                <div className="duo-circle duo-l">
                  <p className="duo-type">カスタマイズ型</p>
                  <h3>ソリューション</h3>
                  <p>
                    お客様ごとの課題に向き合い、
                    <br />
                    最適な仕組みを開発する。
                  </p>
                </div>
                <div className="duo-flow duo-f1">
                  <svg viewBox="0 0 160 40" aria-hidden="true">
                    <path
                      d="M8,36 Q80,-4 150,34"
                      fill="none"
                      stroke="#0b2140"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M141,26 L151,35 L138,38"
                      fill="none"
                      stroke="#0b2140"
                      strokeWidth="1.6"
                    />
                  </svg>
                  <span>
                    知見を抽象化し、
                    <br />
                    プロダクトへ
                  </span>
                </div>
                <div className="duo-flow duo-f2">
                  <svg viewBox="0 0 160 40" aria-hidden="true">
                    <path
                      d="M152,4 Q80,44 10,6"
                      fill="none"
                      stroke="#b38b4d"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M19,14 L9,5 L22,2"
                      fill="none"
                      stroke="#b38b4d"
                      strokeWidth="1.6"
                    />
                  </svg>
                  <span>
                    現場の声を、
                    <br />
                    ソリューションへ
                  </span>
                </div>
                <div className="duo-hub">
                  <img src="/assets/logo.svg" alt="LEAPS" />
                </div>
                <div className="duo-circle duo-r">
                  <p className="duo-type">パッケージ型</p>
                  <h3>プロダクト</h3>
                  <p>
                    開発の成果を汎用化し、
                    <br />
                    より多くの企業へ届ける。
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="service-list">
            <div className="service-row">
              <div className="service-image">
                <img
                  className="svc-main-img"
                  src="/assets/images/services/ai-integration-main-v5a.jpg"
                  alt="ビジネスパーソンの横顔に業務のデータやワークフローが重なるイメージ"
                />
              </div>
              <div className="service-copy">
                <span className="number">01</span>
                <h3>AIインテグレーション</h3>
                <p>
                  既存の業務にAIエージェントを組み込み、業務改革から、それを支える基盤づくりまでを開発します。
                </p>
                <ul className="service-points">
                  <li>
                    <b>業務への組み込み</b>
                    <span>
                      既存の業務フローを整理し、AIエージェントを現場の仕事に組み込みます
                    </span>
                  </li>
                  <li>
                    <b>AIエージェント開発</b>
                    <span>
                      業務に合わせたAIエージェントを、設計から開発まで手がけます
                    </span>
                  </li>
                  <li>
                    <b>基盤づくりと定着</b>
                    <span>
                      データ基盤の整備から、社内で使い続けられる仕組みづくりまで支えます
                    </span>
                  </li>
                </ul>
                <Link
                  className="btn btn-sub service-more"
                  to="/services/ai-integration"
                >
                  詳細はこちら
                </Link>
              </div>
            </div>
            <div className="service-row">
              <div className="service-image">
                <img
                  className="svc-main-img"
                  src="/assets/images/services/blockchain-main-photo.jpg"
                  alt="高層ビル群をネットワークの線がつなぐイメージ"
                />
              </div>
              <div className="service-copy">
                <span className="number">02</span>
                <h3>ブロックチェーン事業開発</h3>
                <p>
                  ブロックチェーン領域の豊富な知見をもとに、プロダクトの企画から設計・開発、リリース後の成長までを一貫して手がけます。
                </p>
                <ul className="service-points">
                  <li>
                    <b>プロダクト企画</b>
                    <span>
                      ブロックチェーンを活かした事業・プロダクトを、構想段階から一緒に描きます
                    </span>
                  </li>
                  <li>
                    <b>設計・開発</b>
                    <span>
                      スマートコントラクト、Webアプリ、決済連携などを設計・開発します
                    </span>
                  </li>
                  <li>
                    <b>リリース後の成長</b>
                    <span>
                      運用・改善を重ね、リリース後の事業の成長まで手がけます
                    </span>
                  </li>
                </ul>
                <Link
                  className="btn btn-sub service-more"
                  to="/services/blockchain"
                >
                  詳細はこちら
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section ground features">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            特徴<strong>Feature</strong>
          </h2>
          <ul className="feature-list">
            <li className="feature-card">
              <span className="feature-num">01</span>
              <h3>
                何をすべきか見えない段階から、
                <br />
                かたちにする
              </h3>
              <p>
                課題の整理や構想づくりから一緒に始め、お客様のニーズに合ったソリューションを、確かな開発力で実際に動くプロダクトとして提供します。
              </p>
            </li>
            <li className="feature-card">
              <span className="feature-num">02</span>
              <h3>
                開発して終わりではなく、
                <br />
                定着と成長まで
              </h3>
              <p>
                リリース後の運用・改善から、現場で使われ続けるための定着、事業のグロースまで。一つのチームで一気通貫で支援します。
              </p>
            </li>
            <li className="feature-card">
              <span className="feature-num">03</span>
              <h3>
                技術の知見から、
                <br />
                本質を見抜いた最適解を
              </h3>
              <p>
                大企業から中小企業まで、AI・ブロックチェーン領域で積み重ねてきた開発実績と技術的な知見をもとに、課題の本質を見抜き、事業に合った最適解を提案します。
              </p>
            </li>
          </ul>
        </div>
      </section>
      <section className="section works">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            実績・事例<strong>Our Works</strong>
          </h2>
          <ul className="client-grid">
            <li className="client-tile">
              <img src="/assets/logos/logo-jtb.png" alt="JTB" />
            </li>
            <li className="client-tile">
              <img
                src="/assets/logos/logo-jta.png"
                alt="JR東海エージェンシー"
              />
            </li>
            <li className="client-tile">
              <img src="/assets/logos/logo-azism.png" alt="AZism" />
            </li>
            <li className="client-tile">
              <img src="/assets/logos/logo-mics.png" alt="mics" />
            </li>
            <li className="client-tile">
              <img
                src="/assets/logos/logo-consensusbase.png"
                alt="ConsensusBase"
              />
            </li>
            <li className="client-tile">
              <img
                src="/assets/logos/logo-meitetsu-mirai.png"
                alt="名鉄未来クリエイツ"
              />
            </li>
            <li className="client-tile">
              <img src="/assets/logos/logo-pizzaday.png" alt="PIZZA DAY" />
            </li>
            <li className="client-tile">
              <img src="/assets/logos/logo-caramel.png" alt="Caramel" />
            </li>
          </ul>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/pizzaday">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/main-11-884x600-1.jpg"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社Spicelink</p>
              <h3>
                サステナブルアパレルブランドに、NFTと暗号資産決済を組み込んだECを構築
              </h3>
              <div className="case-tags">
                <span>アパレル・ファッション</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <HomeMedia />
      <HomeNews />
      <ContactBand />
    </main>
  );
}
